import { connect } from 'react-redux';
import { ApplicationState } from '../../../../store';
import PersonalSectionStart from './index';
import { SectionStatus } from '../../../sections/types';
import { IProps } from '.';

const mapStateToProps = (state: ApplicationState): IProps => {
  const personalStarted = state.student.offer.isPISectionStarted;
  const consentsStarted = state.student.consents.isSectionStarted;
  const financeStarted = state.student.financials.isSectionStarted;

  const personalComplete = state.student.offer.isPISectionComplete;
  const consentsComplete = state.student.consents.isSectionComplete;
  const financeComplete = state.student.financials.isSectionComplete;

  return {
    personalInfoStatus: personalComplete
      ? SectionStatus.complete
      : personalStarted
        ? SectionStatus.incomplete
        : SectionStatus.empty,
    consentsStatus: consentsComplete
      ? SectionStatus.complete
      : consentsStarted
        ? SectionStatus.incomplete
        : SectionStatus.empty,
    financeStatus: financeComplete
      ? SectionStatus.complete
      : financeStarted
        ? SectionStatus.incomplete
        : SectionStatus.empty,
  };
};

export default connect(mapStateToProps)(PersonalSectionStart);
